export default __webpack_public_path__ + "static/media/menu.cfe2eb88.svg";